import React from 'react'
import styles from './styles.module.css'
import { Textarea } from '../../../components/ModalInputs'

const About = ({ lessonData, handleLessonDataChange }) => {
    return (
        <div className={styles.literatureWrapper}>
            <Textarea
                label='Пояснительная записка'
                className={styles.textareaWrapper}
                textareaClassName={styles.textarea}
                value={lessonData?.explanation || ''}
                onChange={(e) => handleLessonDataChange('explanation', e.target.value)}
            />
        </div>
    )
}

export default About
